import { TYPE_META } from "@/components/layers";

const TOOLS = ["audio", "video", "image", "hotspot", "text", "popup", "link", "quiz"];

export const ToolBar = ({ onAdd }) => (
  <div className="pointer-events-auto flex items-center gap-1 rounded-full neu-raised p-2" data-testid="editor-toolbar">
    {TOOLS.map((t) => {
      const { icon: Icon, label } = TYPE_META[t];
      return (
        <button
          key={t}
          onClick={() => onAdd(t)}
          aria-label={`Add ${label}`}
          data-testid={`tool-add-${t}`}
          className="group flex items-center gap-1.5 rounded-full px-3 py-2 text-xs text-[#334155] transition-[background-color,color] hover:bg-[#3D3DF0] hover:text-white hover:text-[#0F172A]"
        >
          <Icon className="h-4 w-4" />
          <span className="hidden md:inline">{label}</span>
        </button>
      );
    })}
  </div>
);
